import React, { createContext, useContext, useState } from "react";

type FormFocusContextType = {
  isFormFocused: boolean;
  setIsFormFocused: (focused: boolean) => void;
};

const FormFocusContext = createContext<FormFocusContextType | undefined>(undefined);

export const FormFocusProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isFormFocused, setIsFormFocused] = useState(false);

  return (
    <FormFocusContext.Provider value={{ isFormFocused, setIsFormFocused }}>
      {children}
    </FormFocusContext.Provider>
  );
};

export const useFormFocus = () => {
  const context = useContext(FormFocusContext);
  if (context === undefined) {
    throw new Error("useFormFocus must be used within a FormFocusProvider");
  }
  return context;
};
